import React from 'react';
import {Link, Box, Typography} from '@customink/pigment-react';
import PropTypes from 'prop-types';

export const VisualSubcategoryLink = (props) => {
  const {imageUrl, title, linkUrl, active, small, onClick} = props;

  return (
    <Box
      sx={{
        padding: small ? '0.375rem' : '0.5rem',
        display: 'flex',
        alignItems: small ? 'flex-start' : 'center',
        justifyContent: 'center'
      }}>
      <Link
        href={linkUrl}
        onClick={() => onClick()}
        sx={{
          height: small ? '6rem !important' : '10rem !important',
          width: small ? '6rem !important' : '10rem !important'
        }}>
        <Box
          sx={{
            width: small ? '6rem' : '10rem',
            height: small ? '6rem' : '10rem',
            display: 'flex',
            borderRadius: '6.25rem',
            alignItems: 'center',
            justifyContent: 'center',
            border: active ? '1px solid #E3E3E3' : 'none',
            boxShadow: active
              ? small
                ? '0px 4px 8px 0px rgba(0, 0, 0, 0.08)'
                : '0px 6px 12px 0px rgba(0, 0, 0, 0.11)'
              : 'none'
          }}>
          <img
            src={imageUrl}
            style={{
              width: active ? '90%' : '100%',
              height: active ? '90%' : '100%',
              borderRadius: '6.25rem',
              backgroundColor: '#f2f2f2'
            }}
          />
        </Box>
        <Typography
          sx={{
            fontSize: small ? '0.8125rem' : '1rem',
            color: 'black',
            display: 'flex',
            justifyContent: 'center',
            textAlign: 'center',
            whiteSpace: 'pre-line',
            fontWeight: active ? '700' : '500',
            lineHeight: small ? '1.015rem' : '1.25rem',
            paddingTop: '1rem'
          }}>
          {title}
        </Typography>
      </Link>
    </Box>
  );
};

VisualSubcategoryLink.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  linkUrl: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  small: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};

VisualSubcategoryLink.defaultProps = {
  small: false,
  active: false,
  onClick: () => {}
};

export default VisualSubcategoryLink;
